(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LocaleDataset", [], factory);
	else if(typeof exports === 'object')
		exports["LocaleDataset"] = factory();
	else
		root["LocaleDataset"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 